var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6226 0.918979L10.0755 6.49279C9.83019 6.87236 10.3019 7.33185 10.6415 7.01221L14.1321 3.79578C14.2264 3.71587 14.3585 3.7758 14.3585 3.91565V13.9645C14.3585 14.1043 14.1887 14.1643 14.1132 14.0644L3.54717 0.679245C3.20755 0.239734 2.71698 0 2.16981 0H1.79245C0.811321 0 0 0.859046 0 1.91787V16.0622C0 17.121 0.811321 17.98 1.81132 17.98C2.43396 17.98 3.01887 17.6404 3.35849 17.061L6.90566 11.4872C7.15094 11.1077 6.67924 10.6482 6.33962 10.9678L2.84906 14.1643C2.75472 14.2442 2.62264 14.1842 2.62264 14.0444V4.01554C2.62264 3.87569 2.79245 3.81576 2.86792 3.91565L13.434 17.3008C13.7736 17.7403 14.283 17.98 14.8113 17.98H15.1887C16.1887 17.98 17 17.121 17 16.0622V1.91787C17 0.859046 16.1887 0 15.1887 0C14.5472 0 13.9623 0.339623 13.6226 0.918979Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNear);
export default __webpack_public_path__ + "static/media/near.f21c31d10b2bed7f73d19e9e3589c7bc.svg";
export { ForwardRef as ReactComponent };